import { render } from "./SwiftAiNotClearedSummaryCard.vue?vue&type=template&id=90dd2cbc&scoped=true"
import script from "./SwiftAiNotClearedSummaryCard.vue?vue&type=script&lang=js"
export * from "./SwiftAiNotClearedSummaryCard.vue?vue&type=script&lang=js"

import "./SwiftAiNotClearedSummaryCard.vue?vue&type=style&index=0&id=90dd2cbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90dd2cbc"]])

export default __exports__